<template>
  <Loader
    :rotate="-90"
    v-bind="$props"
    :value="value"
  />
</template>

<script>
import { Loader } from '@mikmak/components';

export default {
  components: {
    Loader,
  },
  props: {
    size: Number,
    width: Number,
    color: String,
  },
  data() {
    return {
      value: 0,
    };
  },
  mounted() {
    setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 100;
    }, 1000);
  },
};
</script>

<style>
</style>
